var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-8 mx-auto justify-content-center"},[_c('div',{staticClass:"row justify-content-center dashboardstyle"},[_c('canvas',{ref:"chart"})])])])}
var staticRenderFns = []

export { render, staticRenderFns }